/**
 *
 * @module entry
 * @desc {SDK.Services.Session} entry point.
 *
 */

import SessionClient from './sessionClient';
import SessionClientConfiguration from './sessionClientConfiguration';
import SessionClientEndpoint from './sessionClientEndpoint';
import SessionAccountInfo from './sessionAccountInfo';
import SessionDeviceInfo from './sessionDeviceInfo';
import SessionProfileInfo from './sessionProfileInfo';
import SessionEntitlement from './sessionEntitlement';
import SessionInfo from './sessionInfo';
import SessionLocation from './sessionLocation';
import SessionLocationType from './sessionLocationType';

/**
 *
 * @typedef SDK.Services.Session
 * @type {Object}
 *
 * @property {SessionClient} SessionClient
 * @property {SessionClientConfiguration} SessionClientConfiguration
 * @property {SessionClientEndpoint} SessionClientEndpoint
 * @property {SessionLocation} SessionLocation
 * @property {SessionLocationType} SessionLocationType
 *
 */

/**
 *
 * @type {SDK.Services.Session}
 *
 */
export default {

    SessionClient,
    SessionClientConfiguration,
    SessionClientEndpoint,
    SessionAccountInfo,
    SessionDeviceInfo,
    SessionProfileInfo,
    SessionEntitlement,
    SessionInfo,
    SessionLocation,
    SessionLocationType

};



// WEBPACK FOOTER //
// ./src/services/session/entry.js